<template>
  <IQOS :title="$t('serving_fee.title')" class="iqos-empty" v-if="cafe.serving_fee.percent">
      <RoundCheckbox :value="cafe.serving_fee.modes[mode]" @input="toggleMode">
         {{ $t('serving_fee.mode_enable') }}
      </RoundCheckbox>
  </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'
import IQOSActions from '@/components/IQOSActions.vue'

import RoundCheckbox from '@/components/RoundCheckbox.vue'

export default {
    components: {
        IQOS,
        IQOSActions,
        RoundCheckbox
    },
    props: {
        mode: String
    },
    methods: {
        toggleMode() {
            this.$store.commit('setServingFeeMode', {
                mode: this.mode,
                value: !this.cafe.serving_fee.modes[this.mode]
            });
            this.$store.dispatch('saveCafe');
        }
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        }
    }
}
</script>

<style scoped>

</style>